import { ColorSwatch, displayOrNone, Row } from 'components/production/components/AisleContent/SummaryComponents';

/**
 * Summary view for the Banner 1 editor.
 *
 * @param {Object} data - Non-configurable banner data.
 * @param {Object} formData - Configurable banner data.
 */
export default function Banner1EditorSummary({ data, formData }) {
    const item = formData.items?.[0] ?? {};

    return (
        <div className="grid grid-cols-[max-content_1fr] gap-y-1 gap-x-8 items-baseline">
            <Row label="id">
                <p className="text-sm">{displayOrNone(data.id)}</p>
            </Row>
            <Row label="Name">
                <p className="text-sm">{displayOrNone(formData.name)}</p>
            </Row>
            <Row label="Text">
                <p className="text-sm">{displayOrNone(item.text)}</p>
            </Row>
            <Row label="Images (left, right)" labelClass="mb-0.5">
                <ImagePair imageLeftUrl={item.imageLeftUrl} imageRightUrl={item.imageRightUrl} />
            </Row>
            <Row label="Link URL">
                <p className="text-sm">{displayOrNone(item.linkUrl)}</p>
            </Row>
            <Row label="Open in New Tab">
                <p className="text-sm">{item.openLinkInNewTab ? 'Yes' : 'No'}</p>
            </Row>
            <Row label="Background Color" labelClass="transform -translate-y-1">
                <ColorSwatch color={item.bgColor} />
            </Row>
        </div>
    );
}

/**
 * Displays a pair of images (left and right).
 *
 * @param {string} imageLeftUrl - The left image URL.
 * @param {string} imageRightUrl - The right image URL.
 */
function ImagePair({ imageLeftUrl, imageRightUrl }) {
    const BASE_URL = 'https://img-cdn.misfitsmarket.com/';
    return (
        <div className="flex gap-2">
            {imageLeftUrl ? (
                <img alt="" className="max-w-60 h-15 rounded border" src={`${BASE_URL}${imageLeftUrl}`} />
            ) : (
                <span className="italic text-muted-foreground">None</span>
            )}
            {imageRightUrl ? (
                <img alt="" className="max-w-60 h-15 rounded border" src={`${BASE_URL}${imageRightUrl}`} />
            ) : (
                <span className="italic text-muted-foreground">None</span>
            )}
        </div>
    );
}
